import React, { useState } from 'react';

import { useActions } from 'hooks/useActions';
import * as authActions from 'global/actions/authActions';
import { ButtonContainer } from './styles';
import { Button } from 'user/components';
import FreecodeAuthModal from 'components/Modals/FreecodeModals/FreecodeAuthModal/FreecodeAuthModal';

export default function SignUp() {
  const { initialize } = useActions(authActions);

  const [displayModal, setDisplayModal] = useState(false);

  const toggleModal = () => {
    initialize(true);
    setDisplayModal(!displayModal);
  };

  return (
    <ButtonContainer>
      <Button primary onClick={toggleModal}>
        Sign Up
      </Button>
      {displayModal && <FreecodeAuthModal onCancel={toggleModal} />}
    </ButtonContainer>
  );
}
